import { AnalyticsScreenTracker } from '@/lib/analytics/AnalyticsScreenTracker'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type React from 'react'
import { useState } from 'react'
import { SafeAreaProvider, initialWindowMetrics } from 'react-native-safe-area-context'
import { AppQueryPreloader } from './lib/query-preloader/AppQueryPreloader'
import { AppQueryRefresher } from './lib/query-refresher/AppQueryRefresher'

function Providers({ children }: { children: React.ReactNode }) {
	const [queryClient] = useState(() => new QueryClient())

	return (
		<SafeAreaProvider initialMetrics={initialWindowMetrics}>
			<QueryClientProvider client={queryClient}>
				<AppQueryRefresher>
					<AppQueryPreloader>
						<AnalyticsScreenTracker>{children}</AnalyticsScreenTracker>
					</AppQueryPreloader>
				</AppQueryRefresher>
			</QueryClientProvider>
		</SafeAreaProvider>
	)
}

export default Providers
